import { Badge } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { type RootState } from '../reducers';
import SidebarMenu, {
  type SidebarMenuGroup,
  type SidebarMenuItem,
} from './sidebar-menu';

const items: SidebarMenuItem[] = [
  { key: 'all', to: '/orders/all', label: 'All' },
  { key: 'created', to: '/orders/created', label: 'Created' },
  { key: 'paid', to: '/orders/paid', label: 'Paid' },
  { key: 'shipped', to: '/orders/shipped', label: 'Shipped' },
  { key: 'delivered', to: '/orders/delivered', label: 'Delivered' },
  { key: 'cancelled', to: '/orders/cancelled', label: 'Cancelled' },
  { key: 'refunded', to: '/orders/refunded', label: 'Refunded' },
];

const warehouseOrdersGroup: SidebarMenuGroup = {
  key: 'warehouse-orders',
  label: 'Warehouse orders',
  items: [
    {
      key: 'warehouse-orders-overview',
      to: '/orders/warehouse-orders',
      label: 'Overview',
    },
    {
      key: 'warehouse-orders-unpaired-products',
      to: '/orders/warehouse-orders/unpaired-products',
      label: 'Unpaired products',
    },
    {
      key: 'warehouse-orders-audit-log',
      to: '/orders/warehouse-orders/audit-log',
      label: 'Audit log',
    },
    {
      key: 'warehouse-orders-report',
      to: '/orders/warehouse-orders/report',
      label: 'Profit report',
    },
  ],
};

function SidebarOrders(): React.ReactElement {
  const receivedCount = useSelector(
    (s: RootState) => s.Withdrawal.receivedCount,
  );

  return (
    <SidebarMenu
      items={[
        {
          key: 'customer-orders',
          label: 'Orders',
          items: [
            ...items,
            {
              key: 'withdrawals',
              to: '/orders/withdrawals',
              label: (
                <Badge count={receivedCount} size="small" offset={[10, 0]}>
                  Withdrawals
                </Badge>
              ),
            },
          ],
        },
        warehouseOrdersGroup,
      ]}
    />
  );
}

export default SidebarOrders;
